import { render, staticRenderFns } from "./RoteirizacaoAlocacaoPanel.vue?vue&type=template&id=e199c96e&scoped=true&"
import script from "./RoteirizacaoAlocacaoPanel.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoAlocacaoPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoAlocacaoPanel.vue?vue&type=style&index=0&id=e199c96e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e199c96e",
  null
  
)

export default component.exports